import UserProfilePage from './UserProfilePage';

export default UserProfilePage;
